// useUnsavedChangesWarningFunil.js
import { useEffect, useState } from 'react';

const useUnsavedChangesWarningFunil = (isFormDirty, navigate, blockLink) => {
  const [validationFunil, setValidationFunil] = useState({
    click: null,
  });

  useEffect(() => {
    const rotas = JSON.parse(sessionStorage.getItem('rotas')) || [];
    const currentRoute = window.location.pathname;
    const filteredRoutes = rotas.filter(route => route !== currentRoute);
    const recentRoutes = filteredRoutes.slice(-2);
    const lastValidRoute = recentRoutes.length >= 1
      ? recentRoutes[recentRoutes.length - 1]
      : null;

    const handleLinkClickAntes = (event) => {
      const destination = event.target.closest('a').href;
      setValidationFunil(prevState => ({
        ...prevState,
        click: destination
      }));
    };

    const links = document.querySelectorAll('a');
    links.forEach(link => {
      link.addEventListener('click', handleLinkClickAntes);
    });

    const handlePopStateAntes = (event) => {
      setValidationFunil(prevState => ({
        ...prevState,
        click: lastValidRoute
      }));
    };

    window.addEventListener('popstate', handlePopStateAntes);



    if (isFormDirty) {
      let shouldBlockPopState = true;

      const handleBeforeUnload = (event) => {
        if (isFormDirty) {
          event.preventDefault();
          event.returnValue = '';
        }
      };

      const handlePopState = (event) => {

        if(!lastValidRoute.includes('/funil-de-obras')){
          if (isFormDirty && shouldBlockPopState) {
            const confirmationMessage = 'Você tem alterações não salvas. Tem certeza de que deseja sair?';
            const confirmed = window.confirm(confirmationMessage);

            if (confirmed) {
              shouldBlockPopState = false;
              if (lastValidRoute) {
                navigate(lastValidRoute);
              }
            } else {
              window.history.pushState(null, '', window.location.href);
            }
          } else {
            shouldBlockPopState = true;
          }
        }else{
          navigate(lastValidRoute);
        }

      };

      const handleLinkClick = (event) => {
        if (isFormDirty) {
          const destination = event.target.closest('a').href;
          if (!destination.includes('/funil-de-obras')) {
            const confirmed = window.confirm('Você tem alterações não salvas. Tem certeza de que deseja sair?');
            if (!confirmed) {
              event.preventDefault();
            }
          }
        }
      };

      links.forEach(link => {
        if (blockLink && link.text !== blockLink) {
          link.addEventListener('click', handleLinkClick);
        }
      });

      window.history.pushState(null, '', window.location.href);
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('popstate', handlePopState);

      return () => {
        links.forEach(link => {
          link.removeEventListener('click', handleLinkClick);
        });
        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [isFormDirty, navigate, blockLink]);
};

export default useUnsavedChangesWarningFunil;
